// Mock data for Concord Apartments

export const apartmentUnits = [
  {
    id: 1,
    name: "3 Bedroom Apartment",
    bedrooms: 3,
    size: 190,
    price: 330000,
    features: [
      "3 Spacious bedrooms",
      "Modern en-suite bathrooms",
      "Guest toilet",
      "Large sitting room",
      "Modern fitted kitchen",
      "Dining area",
      "Premium finishes throughout"
    ],
    image: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/2zx3ss9p_IMG_1155.jpeg"
  },
  {
    id: 2,
    name: "3+1 Bedroom Apartment",
    bedrooms: 4,
    size: 250,
    price: 350000,
    features: [
      "3 Bedrooms with en-suites",
      "1 Maid's room (self-contained)",
      "Guest toilet",
      "Spacious sitting room",
      "Modern fitted kitchen",
      "Dining area",
      "Premium marble flooring"
    ],
    image: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/fwidoq50_cc523dec-427b-4202-9ec3-acea8f6d1714.jpeg"
  },
  {
    id: 3,
    name: "Penthouse",
    bedrooms: 5,
    size: 530,
    price: 850000,
    features: [
      "5 Luxurious bedrooms with en-suites",
      "Double-height ceilings",
      "Extra maid's room",
      "Grand living area with city views",
      "Premium fitted kitchen",
      "Formal dining room",
      "Private terrace"
    ],
    image: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/gj11mmdp_temp_image_7BA21C6D-F9E8-4E97-AA7C-B251A69F51D6.webp"
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/gj11mmdp_temp_image_7BA21C6D-F9E8-4E97-AA7C-B251A69F51D6.webp",
    alt: "Penthouse Living Room with Double-Height Ceilings",
    category: "Penthouse"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/3bq12qwz_temp_image_A6F8A471-0A28-468C-9B27-AA8728745C62.webp",
    alt: "Grand Living Area with City Views",
    category: "Penthouse"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/fwidoq50_cc523dec-427b-4202-9ec3-acea8f6d1714.jpeg",
    alt: "Elegant Living Room with Designer Chandelier",
    category: "3+1 Bedroom"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/qtti81yp_00b0a247-460d-4959-8f03-4f052b85c784.jpeg",
    alt: "Luxury Bathroom with City Views",
    category: "Bathroom"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/4lpdqfo5_IMG_0026.jpeg",
    alt: "Fitness Center with Modern Equipment",
    category: "Amenities"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/uk4m747r_IMG_0007.jpeg",
    alt: "Swimming Pool with Building Views",
    category: "Amenities"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/1jw6jmnz_IMG_0066.jpeg",
    alt: "Pool Area and Building Exterior",
    category: "Amenities"
  },
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/2zx3ss9p_IMG_1155.jpeg",
    alt: "3+1 Bedroom Spacious Living Room",
    category: "3+1 Bedroom"
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/s9wl56f6_d7ec81dd-f838-4bd4-ac9e-4a4a7c6048ee.jpeg",
    alt: "Modern Kitchen with Dining Area",
    category: "3+1 Bedroom"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/hqjrk0vs_d30a0ecc-8c06-4478-b8b4-1e6c09513e2a.jpeg",
    alt: "Elegant Master Bedroom",
    category: "3+1 Bedroom"
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_nakasero-homes/artifacts/pkmb4kel_807655ed-7fb1-4839-a13d-34c43606c5f7.jpeg",
    alt: "Designer Bathroom with Pattern Tiles",
    category: "3+1 Bedroom"
  }
];

export const amenities = [
  {
    id: 1,
    name: "Swimming Pool",
    description: "Resort-style swimming pool for relaxation",
    icon: "Waves"
  },
  {
    id: 2,
    name: "Fitness Center",
    description: "State-of-the-art gym with modern equipment",
    icon: "Dumbbell"
  },
  {
    id: 3,
    name: "4 Spacious Lifts",
    description: "High-speed elevators for convenient access",
    icon: "ArrowUpDown"
  },
  {
    id: 4,
    name: "Vast Parking Space",
    description: "Secure underground parking with 24/7 security",
    icon: "Car"
  },
  {
    id: 5,
    name: "Coffee Lounge",
    description: "Premium coffee lounge for residents",
    icon: "Coffee"
  },
  {
    id: 6,
    name: "Mini Mart",
    description: "Convenient on-site shopping for daily needs",
    icon: "ShoppingBag"
  },
  {
    id: 7,
    name: "Rooftop Gazebo",
    description: "Spacious rooftop gazebo with panoramic views",
    icon: "Tent"
  },
  {
    id: 8,
    name: "Kids Playground",
    description: "Safe play area for children",
    icon: "Baby"
  }
];

export const contactInfo = {
  phone: "+256 759 757 601",
  email: "Concordapartmentscontacts@gmail.com",
  address: "Nakasero Hill Rd, Kampala, Uganda",
  instagram: "@concord_apartments",
  facebook: "Concord apartments"
};
